import { render, staticRenderFns } from "./loginMain.vue?vue&type=template&id=6de3f1ce"
import script from "./loginMain.vue?vue&type=script&lang=js"
export * from "./loginMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports